import { render, staticRenderFns } from "./SignupForm.vue?vue&type=template&id=64488432&"
import script from "./SignupForm.vue?vue&type=script&lang=ts&"
export * from "./SignupForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports